// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.SideMenuFaq{
    max-width: 100%;
    max-height: 100%;
}

.SideMenuFaq_content {
    padding: 20px;
    overflow-y: auto;
    height: calc(100% - 60px);
}

.SideMenuFaq_section {
    margin-bottom: 30px;
}

.SideMenuFaq_section_title {
    font-size: 18px;
    font-weight: 600;
    color: #2c3e50;
    margin-bottom: 15px;
    padding-bottom: 8px;
    border-bottom: 2px solid #3498db;
    display: flex;
    align-items: center;
}

.SideMenuFaq_section_title::before {
    content: "🔹";
    margin-right: 8px;
    font-size: 16px;
}

.SideMenuFaq_item {
    margin-bottom: 20px;
    padding: 15px;
    background: #f8f9fa;
    border-radius: 8px;
    border-left: 4px solid #3498db;
}

.SideMenuFaq_question {
    font-size: 16px;
    font-weight: 600;
    color: #34495e;
    margin: 0 0 10px 0;
    line-height: 1.4;
}

.SideMenuFaq_question::before {
    content: "Q: ";
    color: #3498db;
    font-weight: 700;
}

.SideMenuFaq_answer {
    font-size: 14px;
    color: #5a6c7d;
    margin: 0;
    line-height: 1.5;
}

.SideMenuFaq_answer::before {
    content: "A: ";
    color: #27ae60;
    font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/sideMenu/SideMenuFaq.css"],"names":[],"mappings":";AACA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,gCAAgC;IAChC,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,gBAAgB;AACpB","sourcesContent":["\n.SideMenuFaq{\n    max-width: 100%;\n    max-height: 100%;\n}\n\n.SideMenuFaq_content {\n    padding: 20px;\n    overflow-y: auto;\n    height: calc(100% - 60px);\n}\n\n.SideMenuFaq_section {\n    margin-bottom: 30px;\n}\n\n.SideMenuFaq_section_title {\n    font-size: 18px;\n    font-weight: 600;\n    color: #2c3e50;\n    margin-bottom: 15px;\n    padding-bottom: 8px;\n    border-bottom: 2px solid #3498db;\n    display: flex;\n    align-items: center;\n}\n\n.SideMenuFaq_section_title::before {\n    content: \"🔹\";\n    margin-right: 8px;\n    font-size: 16px;\n}\n\n.SideMenuFaq_item {\n    margin-bottom: 20px;\n    padding: 15px;\n    background: #f8f9fa;\n    border-radius: 8px;\n    border-left: 4px solid #3498db;\n}\n\n.SideMenuFaq_question {\n    font-size: 16px;\n    font-weight: 600;\n    color: #34495e;\n    margin: 0 0 10px 0;\n    line-height: 1.4;\n}\n\n.SideMenuFaq_question::before {\n    content: \"Q: \";\n    color: #3498db;\n    font-weight: 700;\n}\n\n.SideMenuFaq_answer {\n    font-size: 14px;\n    color: #5a6c7d;\n    margin: 0;\n    line-height: 1.5;\n}\n\n.SideMenuFaq_answer::before {\n    content: \"A: \";\n    color: #27ae60;\n    font-weight: 600;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
